import type { PickerItemValue } from "@design-system/Picker/Picker.types";
import { FilterPickerList } from "@components/pageHeader/filters/FilterPickerList/FilterPickerList";
import type { ActivityFilterRows } from "./activityFilters.types";

interface ActivityFilterPanelProps<T extends PickerItemValue> {
    rows: ActivityFilterRows<T>;
    emptyLabel: string;
}

/** A Filter popover tab listing one Activity filter's rows. */
export const ActivityFilterPanel = <T extends PickerItemValue>({
    rows,
    emptyLabel,
}: ActivityFilterPanelProps<T>) => (
    <FilterPickerList
        {...rows.list}
        value={rows.value}
        onValueChange={rows.onValueChange}
        onDeselect={rows.onClear}
        filter={rows.filter}
        onInputValueChange={rows.onInputValueChange}
        emptyLabel={emptyLabel}
    />
);
